// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class StartNewGameAction implements flatbuffers.IUnpackableObject<StartNewGameActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StartNewGameAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStartNewGameAction(bb:flatbuffers.ByteBuffer, obj?:StartNewGameAction):StartNewGameAction {
  return (obj || new StartNewGameAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStartNewGameAction(bb:flatbuffers.ByteBuffer, obj?:StartNewGameAction):StartNewGameAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StartNewGameAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyStartNewGame;
}

static startStartNewGameAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyStartNewGame);
}

static endStartNewGameAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStartNewGameAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  StartNewGameAction.startStartNewGameAction(builder);
  StartNewGameAction.addType(builder, type);
  return StartNewGameAction.endStartNewGameAction(builder);
}

unpack(): StartNewGameActionT {
  return new StartNewGameActionT(
    this.type()
  );
}


unpackTo(_o: StartNewGameActionT): void {
  _o.type = this.type();
}
}

export class StartNewGameActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyStartNewGame
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return StartNewGameAction.createStartNewGameAction(builder,
    this.type
  );
}
}
